'use client';
import React, { useRef, useEffect } from 'react';
const OutsideClickListener: React.FC<{
  className?: string;
  children: React.ReactNode;
  onOutsideClick: () => void;
}> = ({ className, children, onOutsideClick }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      onOutsideClick();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default OutsideClickListener;
